import {getlangFromCache, languages, Languages} from "../../utils/langs"

export type MultilangString = ILocalizedString[]

export interface ILocalizedString {
    lang: Languages
    value: string
}

// abstract class MultilangStringTools {
export namespace Multilang {
    export abstract class String {
        public static IsMultilangString(object: any) {
            if (Array.isArray(object)) {
                return object.every(
                    (t) =>
                        t?.lang &&
                        (typeof t?.value) === "string"
                )
            }

            return false
        }

        public static CreateNew = (): ILocalizedString[] =>
            languages.map((l) => ({lang: l, value: ""}))

        public static CreateFrom(source: any, lang?: Languages) {
            let local = String.CreateNew()
            if (!source) {
                return local
            } else if (String.IsMultilangString(source)) {
                local = local.map((l) => ({
                    lang: l.lang,
                    value: String.GetValue(source, l.lang, false),
                }))
                return local
            }

            if (typeof source === "string") {
                let result = String.CreateNew()
                result = String.SetValue(result, lang || getlangFromCache(), source)
                return result
            }

            return String.CreateNew()
        }


        public static DeleteFrom(
            localizedStrings: ILocalizedString[],
            lang: Languages,
            useFallback = true
        ): string {
            if (!String.IsMultilangString(localizedStrings)) {
                console.error(
                    "Tried to delete value from a non-localized string! Non-localized string: " +
                    localizedStrings
                );
                return localizedStrings as any;
            }

            const foundIndex = localizedStrings.findIndex((l) => l.lang === lang);

            if (foundIndex !== -1 && localizedStrings[foundIndex].value) 
              return localizedStrings[foundIndex].value;

          if (useFallback) {
                const fallbackIndex = localizedStrings.findIndex((l) => l.value);
                if (fallbackIndex !== -1)
                  return localizedStrings[fallbackIndex].value;
            }

            return "";
        }

        public static SetValue(
            localizedStrings: ILocalizedString[],
            lang: Languages,
            value: string
        ) {
            if (!String.IsMultilangString(localizedStrings)) {
                console.error(
                    "Tried to set value to a non-localized string ! Non-localized string : " +
                    localizedStrings
                )
                return localizedStrings
            }

            if (String.IsMultilangString(value)) {
                console.error(
                    "Tried to set multilang value to a localized string ! Value : " +
                    value
                )
                return localizedStrings
            }

            const foundIndex = localizedStrings.findIndex((l) => l.lang === lang)
            localizedStrings = localizedStrings.map((currentValue, currentIndex) =>
                currentIndex === foundIndex ? {lang, value} : currentValue
            )
            return localizedStrings
        }

        public static GetValue(
            localizedStrings: ILocalizedString[],
            lang: Languages,
            useFallback = true
        ) {
            if (!String.IsMultilangString(localizedStrings)) {
                console.error(
                    "Tried to get multilang value from a non-localized string ! Value : " +
                    localizedStrings
                )
                return typeof localizedStrings === "string" ? localizedStrings : ""
            }
            const found = localizedStrings.find((l) => l.lang === lang)
            const fallback = localizedStrings.find((l) => l.value)
            return found?.value || (useFallback && fallback?.value) || ""
        }

        public static ToString = (
            localizedStrings: ILocalizedString[],
            withEmpty = false
        ) =>
            JSON.stringify(
                localizedStrings.filter(
                    (val: ILocalizedString) => withEmpty || val.value
                )
            )
    }
}

// export const Multilang = {
//   String: {
//     IsMultilangString: MultilangStringTools.IsMultilangString,
//     CreateFrom: MultilangStringTools.CreateFrom,
//     CreateNew: MultilangStringTools.CreateNew,
//     ToString: MultilangStringTools.ToString,
//     GetValue: MultilangStringTools.GetValue,
//     SetValue: MultilangStringTools.SetValue,
//   },
// }

// export type IMultilangString = ILocalizedString[]

// // Constructor
// export const createMultilangStringConstructorByLang =
//   (lang: string) => (value: string) =>
//     multilangStringConstructor(lang, value)

// export const multilangStringConstructor = (
//   lang: string,
//   value: string
// ): ILocalizedString => ({
//   lang,
//   value,
// })

// // GET
// export const isMultilangString = (values: any): boolean => {
//   if (
//     values === undefined ||
//     !Array.isArray(values) ||
//     !values.every ||
//     !values.every(
//       (o: any) => o && o.lang !== undefined && o.value !== undefined
//     )
//   ) {
//     return false
//   }
//   return true
// }

// export const getMultilangValue = (
//   values: ILocalizedString[],
//   lang = "",
//   useFallback = true
// ) => createGetMultilangValueByLang(lang)(values, useFallback)

// export const createGetMultilangValueByLang =
//   (lang: string) =>
//   (values: ILocalizedString[], useFallback = true) => {
//     if (values === undefined) {
//       return ""
//     }
//     const finded = values?.find?.((value) => value.lang === lang)
//     const fallback = values?.find?.((value) => value.value)
//     return finded?.value || (useFallback ? fallback?.value : "") || ""
//   }

// // SET
// export const setMultilangValueByLang = (
//   values: ILocalizedString[],
//   newValue: string,
//   lang: string
// ) => createSetMultilangValueByLang(lang)(values, newValue)

// export const createSetMultilangValueByLang =
//   (lang: string) => (values: ILocalizedString[], newValue: string) => {
//     if (values.some((value) => value.lang === lang)) {
//       return values.map((value) =>
//         value.lang === lang ? multilangStringConstructor(lang, newValue) : value
//       )
//     } else {
//       return [...values, multilangStringConstructor(lang, newValue)]
//     }
//   }

// export const factorizeMultilangList = (multilangString: ILocalizedString[]) =>
//   JSON.stringify(
//     multilangString.filter((val: ILocalizedString) => !isNullOrEmpty(val.value))
//   )

// export default ILocalizedString
